import "./InquiryForm.css";
import React, { useState } from "react";
import { db, auth } from "../../config/firebaseConfig"; // Firebase設定ファイルを適宜変更
import { collection, addDoc, query, where, orderBy, getDocs, serverTimestamp } from "firebase/firestore";


const InquiryForm = () => {
  // 🔹 State 管理
  const [category, setCategory] = useState("不具合報告");
  const [details, setDetails] = useState("");
  const [loading, setLoading] = useState(false);
  const currentProjectID = localStorage.getItem("currentProjectID");

  // 🔹 Firestore のカスタム ID を生成する関数
  const generateCustomID = async () => {
    const today = new Date();
    today.setHours(today.getHours() +9);//日本時間になるように+9とした。
    const dateStr = today.toISOString().split("T")[0].replace(/-/g, ""); // YYYYMMDD 形式

    // Firestore から当日の最新データを取得
    const q = query(
      collection(db, "inquiries"),
      where("id", ">=", `INQ-${dateStr}-0000`),
      where("projectID", "==", currentProjectID),
      orderBy("id", "desc")
    );
    const snapshot = await getDocs(q);

    let newNumber = 1;
    if (!snapshot.empty) {
      const lastDoc = snapshot.docs[0].data();
      const lastID = lastDoc.id;
      const lastNumber = parseInt(lastID.split("-")[2], 10);
      newNumber = lastNumber + 1;
    }

    return `INQ-${dateStr}-${newNumber.toString().padStart(4, "0")}`;
  };

  // 🔹 フォーム送信処理
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!details.trim()) {
      alert("詳細を入力してください");
      return;
    }

    setLoading(true);
    try {
      const user = auth.currentUser;
      const customID = await generateCustomID();

      await addDoc(collection(db, "inquiries"), {
        id: customID,
        category,
        details,
        createdBy: user ? user.displayName : "匿名",
        createdAt: serverTimestamp(),
        email: user.email,
        attachments: [],
        projectID: currentProjectID
      });

      alert("送信しました！");
      setDetails(""); // フォームをリセット
      setCategory("不具合報告");
    } catch (error) {
      console.error("エラー:", error);
      alert("送信に失敗しました");
    }
    setLoading(false);
  };

  return (
    <div className="form-wrapper">
      <h2>問合せフォーム</h2>
      <form onSubmit={handleSubmit} className="form-container">
        <label>カテゴリ</label>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              value="不具合報告"
              checked={category === "不具合報告"}
              onChange={(e) => setCategory(e.target.value)}
            />
            不具合報告
          </label>
          <label>
            <input
              type="radio"
              value="問合せ"
              checked={category === "問合せ"}
              onChange={(e) => setCategory(e.target.value)}
            />
            問合せ
          </label>
          <label>
            <input
              type="radio"
              value="改善要望"
              checked={category === "改善要望"}
              onChange={(e) => setCategory(e.target.value)}
            />
            改善要望
          </label>
        </div>

        <label>詳細</label>
        <textarea
          value={details}
          onChange={(e) => setDetails(e.target.value)}
          required
        />

        <button type="submit" className="submit-button" disabled={loading}>
          {loading ? "送信中..." : "送信"}
        </button>
      </form>
    </div>
  );
};

export default InquiryForm;
